import React, { JSX } from 'react'
import './index.scss'

interface WizardNavigationBarLayout {
    leftContent: JSX.Element | JSX.Element[]
    middleContent: JSX.Element | JSX.Element[]
    rightContent: JSX.Element | JSX.Element[]
}

const WizardNavigationBarLayout = ({ leftContent, middleContent, rightContent }: WizardNavigationBarLayout) => (
    <div className="wizard-navigation-bar-layout">
        <div className="left-content-container">{leftContent}</div>

        <div className="middle-content-container">{middleContent}</div>

        <div className="right-content-container">{rightContent}</div>
    </div>
)

export default WizardNavigationBarLayout
